/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CallRecordingState {
    NotRecording = 1,
    Recording = 2,
    Error = 3,
}
